import { Link } from "react-router-dom";
import { Icon } from "@mui/material";

const ProjectSlideItem = ({to, img, title, content}) => {
  return (
			<div className={`service-item`}>
				<div className="service-img">
					<img style={{width:"100%", height:"100%", objectFit:"cover", verticalAlign:"top"}} src={img} alt=""/>
					<div className="service-hidden-text">
						<div className="project-text">
						<h3>{title}</h3>
						<Link to={to}>Details <Icon fontSize="lg">trending_flat</Icon></Link>
						</div>
					</div>
				</div>
			</div>
  );
};
export default ProjectSlideItem;